import { styled } from "@mui/material";
import SideNavFilter from "components/filter/side/SideNavFilter";
import { CollapsibeDrawer } from "components/layout/CollapsibleDrawer";
import { Outlet } from "components/navigation/Outlet";
import { useState } from "react";
import { MainStyles } from "./MainStyles.";

export default function SideNavLayout() {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <MainStyled>
      <CollapsibeDrawer
        className={`panel ${open ? "open" : "closed"}`}
        onToggle={() => setOpen(!open)}
        open={open}
        padding={0}
        variant="persistent"
        elevation={0}
      >
        <SideNavFilter />
      </CollapsibeDrawer>
      <Outlet />
    </MainStyled>
  );
}

const MainStyled = styled(MainStyles)`
  .panel {
    display: flex;
    justify-content: stretch;
    transition: flex-basis 320ms ease-out;

    flex: 1 0 20%;
    &.closed {
      flex: 0 1 0%;
    }
  }
`;
